import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
	providedIn: 'root',
})
export class CustomPromptuaryValidatorsService {
	//Validators customizados usados no prontuário, retorna um objeto caso contenha erro, se válido retorna null

	requiredWhenOutcomeIsEqualTo(field, equalTo): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const outcome = control.parent?.get('outcome')?.value;
			if (
				outcome === equalTo &&
				field === 'outcomeForwardJourneySessionNumber' &&
				typeof control.value === 'number'
			) {
				return null;
			}

			if (!control.value && outcome === equalTo) {
				return { [field]: { empty: control.value } };
			}

			return null;
		};
	}

	requiredWhenHasLinks(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const links = control.parent?.get('links');
			if (links?.value?.length > 0 && !control.value) {
				return { description: { empty: control.value } };
			}
			return null;
		};
	}

	alarmSignalsReasonValidator(value: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (value) {
				return control.value ? null : { required: true };
			} else {
				return null;
			}
		};
	}
}
